import React from "react";

const Card = React.memo(function Card({ children, className = "" }) {
  return <div className={`card ${className}`}>{children}</div>;
});

export default Card;
